import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const Dropdown = ({ values, size, required, displayEmpty, fullWidth, helperText, label, placeholder, placeholderDisabled, getOptionLabel, getOptionValue, getOptionStyles, ...rest }) => {
    return (
        <FormControl 
            required={required}
            fullWidth={fullWidth} 
            variant='outlined'
            size={size}        
        >
           {label && 
                <InputLabel 
                    shrink={displayEmpty && !!placeholder}  
                    id={`select-outlined-label-${label}`}
                >
                    {label}
                </InputLabel>}
            <Select
displayEmpty={displayEmpty} labelId={`select-outlined-label-${label}`} label={label} {...rest} MenuProps={{
                PaperProps: { style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP } }
            }}
            >
            {placeholder &&
                <MenuItem value="" disabled={placeholderDisabled}>
                    {placeholder}
                </MenuItem>}
            {
                values &&
                values.map((option, index) => {
                    const styles = getOptionStyles(option);
                    const label = getOptionLabel(option);
                    const value = getOptionValue(option);

                    return (
                        <MenuItem 
                            key={index} 
                            value={value} 
                            disabled={option?.disabled} 
                            className={styles}
                        >
                            {label}
                        </MenuItem>
                    )
                })
            }
            </Select>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    )
}

Dropdown.defaultProps = {
    getOptionLabel: (option) => option.label,
    getOptionValue: (option) => option.value,
    getOptionStyles: (option) => "",
    placeholderDisabled: true
}

Dropdown.prototype = {
    values: PropTypes.array,
    getOptionLabel: PropTypes.func,
    getOptionValue: PropTypes.func,
    placeholderDisabled: PropTypes.bool
}

export default Dropdown;